import { render, staticRenderFns } from "./match_day_detail.vue?vue&type=template&id=62f08a87&scoped=true"
import script from "./match_day_detail.vue?vue&type=script&lang=js"
export * from "./match_day_detail.vue?vue&type=script&lang=js"
import style0 from "./match_day_detail.vue?vue&type=style&index=0&id=62f08a87&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f08a87",
  null
  
)

export default component.exports